import { useEffect, useState, useRef } from "react"
import { useTranslation } from "react-i18next";
// 指向加了「條碼代碼 + 條碼起訖號」篩選的館藏維護複本（原 BookDetail 不動）
import BookDetail from "./BackStage/BookDetail/book_detail_barcode_filter";
import { Row, Col, Button } from '../../ui/ot'
import CheckOutTableModal from "./check_out_table_modal";
const LibraryBookDetailBarcodeFilter = ({
    keyPrefix = 'library.bookdetail',
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checkOutParams, setCheckOutParams] = useState({
        itemnumber: null,
        barcode: null,
        biblionumber: null,
    })
    return (<Row>
        <Col>
            <CheckOutTableModal
                propsOpen={isModalOpen}
                propsSetOpen={setIsModalOpen}
                {
                ...checkOutParams
                }
            />
        </Col>
        <Col span={24}>
            <BookDetail
                holdingCustomColumns={[
                    {
                        title: t(`borrow_records`),
                        dataIndex: 'item_itemnumber',
                        key: 'item_itemnumber',
                        render: (text, record, index) => {
                            return <>
                                <Button
                                    type="link"
                                    onClick={() => {
                                        setIsModalOpen(true)
                                        setCheckOutParams((pre) => {
                                            return {
                                                ...pre,
                                                itemnumber: text,
                                                barcode: record?.item_barcode,
                                                biblionumber: record?.bib_biblionumber,
                                            }
                                        })
                                    }} >
                                    借閱歷史
                                </Button>
                            </>
                        }
                    },
                ]}
            />
        </Col>
    </Row>)
}

export default LibraryBookDetailBarcodeFilter